export default __webpack_public_path__ + "static/media/detail_big_9_3.cf5e258b.jpg";